import { GET_401_ERROR } from './constants';

export const get401Error = () => ({
  type: GET_401_ERROR,
});
